/**
 * @generated SignedSource<<29d9603a55da8387b3696ea24dcd0e6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemLiveArticleTimelineLiveContent$data = {
  readonly customTime: number | null;
  readonly entityId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "itemLiveArticleTimelineLiveContent";
};
export type itemLiveArticleTimelineLiveContent$key = {
  readonly " $data"?: itemLiveArticleTimelineLiveContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemLiveArticleTimelineLiveContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "itemLiveArticleTimelineLiveContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customTime",
      "storageKey": null
    }
  ],
  "type": "LiveContent",
  "abstractKey": null
};

(node as any).hash = "f5468e428fcda61d2134bdc43b489ca2";

export default node;
